import React, { useEffect, useState, useContext, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import {
    SelectBankAlle as BANK_SELECT,
    CashWithdrawalAlle as CASH_WITHDRAWAL,
    BalanceEnquiryAlle as BALANCE_ENQUIRY
} from 'Components/Api/AEPSAPI';

import Box from '@material-ui/core/Box';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Last10RechargeReport } from 'Pages/InnerPages/Report/Last10RechargeReport';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    ListItemIcon,
    Link
} from '@material-ui/core';
import { AEPS_CODE } from 'Components/Helper/Messages';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

import { BalanceContext } from 'Components/BalanceContext';

import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import HOCLoader from 'Components/Loader/HOCLoader';

import { Event } from 'ReactGa';
import InputLabel from 'Components/Inputes/InputLabel';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import RechargeIcon from 'Components/SvgButtons/RechargeIcon';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
const CustomContainer = HOCLoader(Container);

export const AlleAEPS = () => {
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const [RefreshRandom, setRefreshRandom] = useState(0);

    let serviceCode = AEPS_CODE;

    const formRef = useRef();
    const { DashboardBalanceUpdate } = useContext(BalanceContext);

    const classes = commonStyle();

    const [Operator, setOperator] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [shouldDisplayAmount, setShouldDisplayAmount] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});

    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [InWords, setInWords] = useState('');
    const [bankList, setBankList] = useState([]);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');

    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [bankDefault, setBankDefault] = useState({
        IIN: '',
        BankName: 'Select Bank'
    });
    const [formObj, setFormObj] = useState({
        ServiceID: serviceCode,
        OperatorID: '',
        AadhaarNumber: '',
        Bank: bankDefault,
        IIN: '',
        BankName: '',
        ConsumerNumber: '',
        Amount: '',
        InWords: '',
        OperatorName: '',
        OperatorImagePath: '',
        Pin: '',
        IsPin: isPin
    });

    const reset = () => {
        setInWords('');
        setBankDefault({
            IIN: '',
            BankName: 'Select Bank'
        });
        setFormObj({
            ServiceID: serviceCode,
            OperatorID: '',
            AadhaarNumber: '',
            Bank: bankDefault,
            ConsumerNumber: '',
            Amount: '',
            InWords: '',
            OperatorName: '',
            OperatorImagePath: '',
            Pin: '',
            IsPin: isPin
        });
    };

    const validationSchema = Yup.object({
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator'),
        ConsumerNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number'),

        Pin: Yup.number().when(['IsPin'], {
            is: (isPin) => isPin === 'true',
            then: Yup.number().required('Please enter pin')
        }),
        AadhaarNumber: Yup.string()
            .length(12, 'Must be 12 digit')
            .required(PLEASE_PROVIDE_VALID + 'Aadhaar Number')
    });

    const selectBank = async () => {
        setLoadingOpen(true);
        const response = await BANK_SELECT();
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };

    const submitHandle = async (values, { resetForm }) => {
        if (loadingOpen) return;

        let op = Operator.filter((o) => o.OperatorID === values.OperatorID);

        values.OperatorName = op[0].OperatorName;
        values.OperatorImagePath = op[0].Path;

        setIsAlertOpen(true);
        setConfirmAlertRequest(values);
    };

    const GetOperatorName = (OperatorID) => {
        var opName = '';
        opName = Operator.find(function (values) {
            if (values.OperatorID === OperatorID) return values.OperatorName;
            return '';
        });

        return opName.OperatorName;
    };

    const Proceed = async (values) => {
        setLoadingOpen(true);

        setResponseMessage('');
        setIsError(false);

        const { status, xmldata } = await GetFingerPrint('');

        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;

        Event('AEPS', 'AEPS', await GetOperatorName(values.OperatorID));
        let response = '';

        if (values.OperatorName.includes('Balance')) {
            var requestObj = {
                AadhaarNumber: values.AadhaarNumber,
                ConsumerNumber: values.ConsumerNumber,
                IIN: values.IIN,
                BankName: values.Bank.BankName,
                FingerPrint: fingerPrintXML
            };
            var request = JSON.stringify(requestObj);

            response = await BALANCE_ENQUIRY(request);
        } else {
            var requestObjCW = {
                AadhaarNumber: values.AadhaarNumber,
                ConsumerNumber: values.ConsumerNumber,
                IIN: values.IIN,
                BankName: values.Bank.BankName,
                FingerPrint: fingerPrintXML,
                Amount: values.Amount
            };
            var requestCW = JSON.stringify(requestObjCW);

            response = await CASH_WITHDRAWAL(requestCW);
        }

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        await DashboardBalanceUpdate();

        setRefreshRandom(Math.random(0));

        var data = JSON.parse(response.data);

        if (!response.status) {
            setResponseMessage(data.Message);
            setSeverity('error');
            setIsError(true);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);

            return;
        }
        setSeverity('success');
        setResponseMessage(
            data.Message +
                ', Available Balance:' +
                data.AvailableBalance +
                ' , BankRRN:' +
                data.BankRRN
        );
        setStatus(data.Status);
        setResponseAlert(data);
        setIsResponseAlertOpen(true);

        setIsError(true);

        if (data.Status === 'FAILURE') {
            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);

            setSeverity('error');
        }

        if (formRef.current) formRef.current.resetForm();
    };

    const OnChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) return;
        setInWords(NumberToWord(value));
        setFieldValue('InWords', NumberToWord(value));
    };

    const handleOperatorChange = (name, value, setFieldValue) => {
        setFieldValue(name, value);

        let op = GetOperatorName(value);
        if (op.includes('Balance')) {
            setShouldDisplayAmount(false);

            return;
        }
        setShouldDisplayAmount(true);
    };

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    useEffect(() => {
        fetchConsumerNumberFontSize();
        selectBank();
        selectOperator(serviceCode);
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submitHandle}
                resetForm={formObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            bankDefault
                                                        }
                                                        SubFieldName="BankName"
                                                        FieldName="Bank"
                                                        name="Bank"
                                                        onSearchCallback={(
                                                            text
                                                        ) => {}}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'IIN',
                                                                value.IIN
                                                            );

                                                            setFieldValue(
                                                                'BankName',
                                                                value.BankName
                                                            );

                                                            setBankDefault({
                                                                IIN: value.IIN,
                                                                BankName:
                                                                    value.BankName
                                                            });

                                                            // formRef.current.values.IIN = value.IIN;
                                                            // formRef.current.values.BankName = value.BankName;
                                                        }}
                                                        options={bankList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.BankName}
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.BankName ===
                                                            value.BankName
                                                        }
                                                        textFieldProps={{
                                                            label: 'Bank'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Aadhaar Number"
                                                        name="AadhaarNumber"
                                                        icon="mobile"
                                                        placeholder="Aadhaar Number"
                                                        title="Aadhaar Number"
                                                        length="12"
                                                        typed_length={1}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Consumer Number"
                                                        name="ConsumerNumber"
                                                        icon="mobile"
                                                        placeholder="Consumer Number"
                                                        title="Consumer Number"
                                                        length="10"
                                                        typed_length={1}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialSelect
                                                        label="Select Type"
                                                        name="OperatorID"
                                                        title="Type"
                                                        size="small"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            handleOperatorChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                    >
                                                        {Operator.map(
                                                            (item) => (
                                                                <MenuItem
                                                                    key={
                                                                        item.OperatorID
                                                                    }
                                                                    value={
                                                                        item.OperatorID
                                                                    }
                                                                >
                                                                    <ListItemIcon
                                                                        style={{
                                                                            verticalAlign:
                                                                                'middle'
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                item.Path
                                                                            }
                                                                            height={
                                                                                30
                                                                            }
                                                                            width={
                                                                                30
                                                                            }
                                                                            alt={
                                                                                item.OperatorName
                                                                            }
                                                                        />
                                                                    </ListItemIcon>
                                                                    {
                                                                        item.OperatorName
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </MaterialSelect>
                                                </Grid>
                                                {shouldDisplayAmount ? (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                    >
                                                        <MaterialCurrency
                                                            font_size={
                                                                consumerNumberFontSize
                                                            }
                                                            name="Amount"
                                                            label="Amount"
                                                            placeholder="Amount"
                                                            autoComplete="new-password"
                                                            size="normal"
                                                            max={10000}
                                                            title="Amount"
                                                            onCustomCallback={(
                                                                value
                                                            ) => {
                                                                OnChange(
                                                                    value,
                                                                    setFieldValue
                                                                );
                                                            }}
                                                        />
                                                        <InputLabel
                                                            color="green"
                                                            value={InWords}
                                                        />
                                                    </Grid>
                                                ) : null}
                                                {isPin === 'true' ? (
                                                    <Grid item xs>
                                                        <MaterialNumberField
                                                            label="Pin"
                                                            type="password"
                                                            name="Pin"
                                                            placeholder="Pin"
                                                            title="Pin"
                                                            length={4}
                                                        />
                                                    </Grid>
                                                ) : null}
                                            </Grid>
                                        </Paper>
                                        <Grid className={classes.footerGrid}>
                                            <Box
                                                className={classes.flexReverse}
                                            >
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                >
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <SecondaryButton
                                                                    disabled={
                                                                        loadingOpen
                                                                    }
                                                                    endIcon={
                                                                        <ResetIcon />
                                                                    }
                                                                    title="Reset"
                                                                    onClick={() => {
                                                                        reset();
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-md-7">
                                                                <PrimaryButton
                                                                    title="Proceed"
                                                                    disabled={
                                                                        loadingOpen
                                                                    }
                                                                    endIcon={
                                                                        <RechargeIcon />
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <Last10RechargeReport
                                    ServiceID={serviceCode}
                                    refreshRandom={RefreshRandom}
                                />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="AEPS"
                    message="Are you sure to do transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Proceed(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={status}
                    ServiceID={AEPS_CODE}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
            <Paper>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <h2 className={classes.PaperHead_h2}>
                        Download Links for major RD service
                    </h2>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <h3 className={classes.PaperHead_h2}>
                                MANTRA RD Service
                            </h3>
                            <label className={classes.Provider_Format}>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/mantra/MantraRDService_1.0.3.exe"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'MantraRDService_1.0.3.exe'}
                                </Link>
                                <br></br>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/mantra/MFS100Driver_9.1.0.0.exe"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'MFS100Driver_9.1.0.0.exe'}
                                </Link>
                            </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <h3 className={classes.PaperHead_h2}>
                                MORPHO RD Service
                            </h3>
                            <label className={classes.Provider_Format}>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/Morpho/MorphoRd.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'MorphoRd.zip'}
                                </Link>
                            </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <h3 className={classes.PaperHead_h2}>
                                PRECIESION RD Service
                            </h3>
                            <label className={classes.Provider_Format}>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/next-rd-services/RDService_L0_ConfigTool_1_0_Windows_Setup.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'RDService_L0_Windows_Setup.zip'}
                                </Link>
                                <br></br>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/precision/Precisionrdservice.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'Precisionrdservice.zip'}
                                </Link>
                                <br></br>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/precision/ManagementClient.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'ManagementClient.zip'}
                                </Link>
                            </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <h3 className={classes.PaperHead_h2}>
                                SECUGEN RD Service - 32 bit
                            </h3>
                            <label className={classes.Provider_Format}>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/secugen/SecuGenDriverInstall32.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'SecuGenDriverInstall32.zip'}
                                </Link>
                                <br></br>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/secugen/SecugenRdservice.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'SecugenRdservice.zip'}
                                </Link>
                            </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <h3 className={classes.PaperHead_h2}>
                                SECUGEN RD Service - 64 bit
                            </h3>
                            <label className={classes.Provider_Format}>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/secugen/SecuGenDriverInstall64.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'SecuGenDriverInstall64.zip'}
                                </Link>
                                <br></br>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/secugen/SecugenRdservice.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'SecugenRdservice.zip'}
                                </Link>
                            </label>
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <h3 className={classes.PaperHead_h2}>
                                NEXT RD Service
                            </h3>
                            <label className={classes.Provider_Format}>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/next-rd-services/NXT-RDService_L0_1_0_2_0_Windows_Setup.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'NXT-RDService_L0_1_0_2_0.zip'}
                                </Link>
                                <br></br>
                                <Link
                                    href="https://docs.paysprint.in/rd-service/next-rd-services/RDService_L0_ConfigTool_1_0_Windows_Setup.zip"
                                    target="_blank"
                                    underline="always"
                                >
                                    {'RDService_L0_ConfigTool_1_0.zip'}
                                </Link>
                            </label>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
